import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'store/reducer';
import dark from 'styles/themes/dark';
import light from 'styles/themes/light';

export const useAppTheme = () => {
  const { theme } = useSelector((state: RootState) => state.theme);
  const [appTheme, setAppTheme] = useState(dark);

  useEffect(() => {
    const isDarkMode = theme === 'dark';
    setAppTheme(isDarkMode ? dark : light);

  }, []);

  return { theme: appTheme };
};

